import React from 'react';
import './QuestionNavigator.css';

function QuestionNavigator({ questions, currentIndex, answers, flagged, onJump, onClose }) {
  return (
    <div className="navigator-overlay" onClick={onClose}>
      <div className="navigator" onClick={(e) => e.stopPropagation()}>
        <div className="navigator-header">
          <span>Question Navigator</span>
          <button className="navigator-close" onClick={onClose} aria-label="Close navigator">×</button>
        </div>
        <div className="navigator-legend">
          <span><i className="navigator-dot navigator-dot-answered" /> Answered</span>
          <span><i className="navigator-dot navigator-dot-flagged" /> Flagged</span>
          <span><i className="navigator-dot navigator-dot-current" /> Current</span>
          <span><i className="navigator-outline-swatch navigator-outline-swatch-easy" /> Easy</span>
          <span><i className="navigator-outline-swatch navigator-outline-swatch-medium" /> Medium</span>
          <span><i className="navigator-outline-swatch navigator-outline-swatch-hard" /> Hard</span>
        </div>
        <div className="navigator-grid">
          {questions.map((q, idx) => {
            const isAnswered = Boolean(answers[q.id]);
            const isFlagged = Boolean(flagged[q.id]);
            const isCurrent = idx === currentIndex;
            const difficulty = (q.difficulty || '').toLowerCase();
            return (
              <button
                key={q.id}
                className={[
                  'navigator-cell',
                  isCurrent ? 'navigator-cell-current' : '',
                  isAnswered ? 'navigator-cell-answered' : '',
                  isFlagged ? 'navigator-cell-flagged' : '',
                  difficulty ? `navigator-cell-diff-${difficulty}` : '',
                ].join(' ').trim()}
                onClick={() => {
                  onJump(idx);
                  onClose();
                }}
                title={`Question ${idx + 1}${difficulty ? ` (${difficulty})` : ''}${isFlagged ? ' (flagged)' : ''}${isAnswered ? ' (answered)' : ''}`}
              >
                {idx + 1}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default QuestionNavigator;
